import React from 'react';
import { FileUpload } from 'src/v2/icons/FileUpload';

export const DragContentPlaceholder: React.FC = ({ children }) => (
  <span className="c-attachment__label">
    <FileUpload />
    {children}
  </span>
);
